import { Injectable } from "@angular/core";

import { ExcelService } from "dspx-core";

import { API_ENDPOINTS } from "../constants/api-endpoints.constants";
import { ExportToDataTablesRequest } from "../interfaces/export-to-data-tables-request.interface";
import { ExportToDataTablesResponse } from "../interfaces/export-to-data-tables-response.interface";
import { AppDataService } from "./app-data.service";

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {

  constructor(
    private appDataService: AppDataService,
    private excelService: ExcelService) {
  }

  // Exports to XLSX

  exportCoiFormsToXlsx(request: ExportToDataTablesRequest): void {
    this.exportToXlsx(API_ENDPOINTS.coiForm.exportToDataTables, request, 'COI_Forms');
  }

  exportDopiFormsToXlsx(request: ExportToDataTablesRequest): void {
    this.exportToXlsx(API_ENDPOINTS.dopiForm.exportToDataTables, request, 'DOPI_Forms');
  }

  exportGbhFormsToXlsx(request: ExportToDataTablesRequest): void {
    this.exportToXlsx(API_ENDPOINTS.gbhForm.exportToDataTables, request, 'GBH_Forms');
  }

  private exportToXlsx(
    apiEndpoint: string,
    request: ExportToDataTablesRequest,
    fileNamePrefix: string,
    onSuccess: (response: ExportToDataTablesResponse, fileName: string) => void = null): void {

    this.appDataService.getDataTableSet(apiEndpoint, request, (response: ExportToDataTablesResponse, transientId: string) => {
      const fileName = this.exportDataTablesToXlsx(response, fileNamePrefix, transientId);
      onSuccess?.(response, fileName);
    });
  }

  private exportDataTablesToXlsx(
    response: ExportToDataTablesResponse,
    fileNamePrefix: string,
    transientId: string) {

    transientId ??= this.appDataService.getTransientId();

    const fileName = `${fileNamePrefix}_${transientId}.xlsx`;

    const workSheetInfos = response
      ?.dataTables
      ?.map(dataTable => ({ workSheetName: dataTable?.tableName, workSheetData: dataTable?.data }))
      ?? [];

    this.excelService.writeWorkBookToFile(fileName, workSheetInfos);

    return fileName;
  }
}
